import React from 'react';
import { AIMessage, ForceIntoVisibilityClassName } from '@bingads-webui/ads-copilot-ui';
import { useI18nContext } from '@bingads-webui/copilot-i18n';
import { mergeClasses } from '@fluentui/react-components';
import { LIVE_AGENT_LIMITED_SUPPORT_STRINGS } from '../helpers';

export const ENGLISH_ONLY_SUPPORTED_LOCALES = ['zh-cn'];

interface ILiveAgentSupportClosedProps {
  customPlaceholder?: string;
  onFeedbackButtonClick: any;
  weekdayTime?: string;
  timezoneNote?: string;
}

interface ILiveAgentUnsupportedProps {
  onFeedbackButtonClick: any;
}

export const LiveAgentSupportClosed: React.FC<ILiveAgentSupportClosedProps> = ({
  customPlaceholder,
  onFeedbackButtonClick,
  weekdayTime,
  timezoneNote,
}: ILiveAgentSupportClosedProps) => {
  const i18n = useI18nContext()!;
  const {
    header, hours, weekendCloseNote, footer,
  } = LIVE_AGENT_LIMITED_SUPPORT_STRINGS;
  // 24/7 locales have no hours to show - they close only for a holiday.
  const hoursBlock = (weekdayTime && timezoneNote)
    ? `${i18n.getString(hours)}<br/>${i18n.getString(weekdayTime)}<br/>${i18n.getString(weekendCloseNote)}<br/>${i18n.getString(timezoneNote)}<br/><br/>`
    : '';
  const computedMessage = `${i18n.getString(header)}<br/><br/>${hoursBlock}${i18n.getString(footer)}`;
  const textMessage = customPlaceholder
    ? i18n.getString(customPlaceholder)
    : computedMessage;
  return (
    <div style={{ display: 'flex', float: 'left', flexDirection: 'column' }}>
      <AIMessage
        className={mergeClasses('ai-message-live-agent', ForceIntoVisibilityClassName)}
        message={{
          text: textMessage,
        } as any}
        showReferences={false}
        showCopyButton={false}
        onFeedbackButtonClick={onFeedbackButtonClick}
      />
    </div>
  );
};

export const LiveAgentUnsupported: React.FC<ILiveAgentUnsupportedProps> = ({ onFeedbackButtonClick }) => {
  const i18n = useI18nContext()!;
  return (
    <div style={{ display: 'flex', float: 'left', flexDirection: 'column' }}>
      <AIMessage
        className={mergeClasses('ai-message-live-agent', ForceIntoVisibilityClassName)}
        message={{
          text: i18n.getString(_TL_('I\'m sorry, the live chat isn\'t available in your country/region. Please feel free to ask me a question to receive quick assistance.')),
        } as any}
        showReferences={false}
        showCopyButton={false}
        onFeedbackButtonClick={onFeedbackButtonClick}
      />
    </div>
  );
};
